if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"dxpInstanceManagement","remotes":[{"alias":"dxpConsoleCore-mf","name":"dxpConsoleCore","entry":"./console-core/remoteEntry.js","shareScope":"default"},{"alias":"dxpInstanceManagement-mf","name":"dxpInstanceManagement","entry":"./instance-management/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^webpack_sharing_consume_default_(r(eact\-(dom_react|router\-dom_react\-router)\-dom|xjs_rxjs)|clsx_clsx|date\-fns_date\-fns)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}